/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2020
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import { useSelector } from "react-redux";

import PageLayout from "./PageLayout";
import CoveredRoutesTable from "./CoveredRoutesTable";
import Loader from "../components/Loader";
import FiltersContainer from "./FiltersContainer";
import SearchResultsContainer from "./SearchResultsCountContainer";

import { withTheme } from "@material-ui/core/styles";

const GoTrackContainer = ({ theme }) => {
  const isFetching = useSelector((state) => state.coveredRoutes.isFetching);
  const searchTerm = useSelector((state) => state.filters.searchTerm);

  return (
    <PageLayout
      pageTitle="RouteConnect™ Tracking"
      documentTitle="RouteConnect™ - Covered Routes"
      data-testid="gotrack"
    >
      {
        (!isFetching && searchTerm) && <SearchResultsContainer />
      }
      <FiltersContainer />
      <CoveredRoutesTable />
      {isFetching && <Loader />}
    </PageLayout>
  );
};

export default withTheme(GoTrackContainer);
